import React from 'react';
import { func,string } from 'prop-types';
import style from './style';

function Searchbar({onChange,onCancel,value,placeholder,...props}) {
	return(
		<style.Wrapper {...props}>
			<div>
				<style.TextInput 
					value={value}
					placeholder={placeholder}
					onChange={onChange}
				/>
			</div>
			<div id='button-wrapper'>
				<style.IconButton onClick={onCancel}>
					<style.RemoveIcon />
				</style.IconButton>
			</div>
		</style.Wrapper>
	);
}
Searchbar.propTypes = {
	value : string,
	placeholder : string,
	onCancel : func,
	onChange : func,
};


export default Searchbar;